/* istanbul ignore file */
import { FormRow } from 'framework/ui/layout';
import { DateInput, TextInput } from 'framework/form';
import { useDateService } from 'framework/utils';

const HealthcheckForm = () => {
  const { getToday } = useDateService();
  return (
    <>
      <FormRow colMd={12} colXl={6}>
        <DateInput source="date" label="Date" maxDate={getToday()} />
        <TextInput source="description" label="Description" />
      </FormRow>
    </>
  );
};

export default HealthcheckForm;
